import { aspectRatios } from '../constant/enum';
import {
  FileType,
  FileWithValidation,
  IMAGE_NAME_FORMAT,
  Max_File_Size,
  VALID_PRODUCT_NAME,
  VALID_RATIOS,
} from '../types/menu/menu.types';

export const validateFiles = (
  files: FileType[],
  existingFiles?: FileWithValidation[],
  presentItemsIdList?: number[]
): FileWithValidation[] => {
  const existingFileNames = new Set((existingFiles ?? []).map((f) => f.file.name));

  return files.map((file) => {
    const name = file.name.split('.')[0]; // Remove extension
    const [rawId, ratio, deviceName] = name.split('-');

    const parsedId = parseInt(rawId, 10);
    const isValidId = !isNaN(parsedId);
    const isValidRatio = VALID_RATIOS.includes(ratio);
    const isValidDeviceName = deviceName ? VALID_PRODUCT_NAME.includes(deviceName) : true;

    let error: string | undefined = undefined;
    if (existingFileNames.has(file.name)) {
      error = 'Duplicate image';
    } else if ((!isValidId && !isValidRatio) || isNaN(parsedId) || !IMAGE_NAME_FORMAT.test(file.name)) {
      error = 'Incorrect name';
    } else if (presentItemsIdList && !presentItemsIdList.includes(parsedId)) {
      error = 'Item does not exist for this image';
    } else if (!isValidId) {
      error = 'Invalid ID';
    } else if (!isValidRatio) {
      error = ratio ? 'Invalid ratio' : 'Incorrect name';
    } else if (deviceName && !isValidDeviceName) {
      error = 'Invalid device name';
    } else if (deviceName && isValidDeviceName && ratio && ratio == aspectRatios['16x9']) {
      error = '16x9 ratio is not allowed for this device';
    } else if (file.size > Max_File_Size) {
      error = 'File size should be less than 5MB';
    }

    const uniqueId = crypto.randomUUID().slice(0, 7);

    return {
      file,
      meta: {
        parsedId: isValidId ? parsedId : undefined,
        ratio: isValidRatio ? ratio : undefined,
        deviceName: deviceName || 'POS',
        error,
        uniqueId,
      },
    };
  });
};

export const sortImageFiles = (files: FileWithValidation[]): FileWithValidation[] => {
  return files.sort((a, b) => {
    if (a.meta.parsedId == null && b.meta.parsedId == null) return 0;
    if (a.meta.parsedId == null) return 1;
    if (b.meta.parsedId == null) return -1;
    return (a.meta.parsedId ?? 0) - (b.meta.parsedId ?? 0);
  });
};
